/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ByteToSizeCell } from "../../framework/forms/helpercomponents/CustomGridCells/ByteToSizeCell";


export const BucketsEditForm = (props) => {

  const lang = useTranslation();

  const [dataItem, setDataItem] = useState({});
  const [bucketConfigurations, setBucketConfigurations] = useState([]);
  const [fileLoading, setFileLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    loadcombo();
  }, [])

  const loadcombo = async () => {

    const bucketConfigurationRes = await API.getDataLookup(ENTITYNAME.BUCKET_CONFIGURATIONS, { sort: { SID: 1 } });
    setBucketConfigurations(bucketConfigurationRes.data);

    if (props.item.SID > 0) {
      setDataItem({
        SID: props.item.SID,
        Name: props.item.Name,
        BucketConfiguration: bucketConfigurationRes.data.find((x) => x._id == props?.item?.BucketConfiguration_id) ?? props?.item?.BucketConfiguration_id,
        FolderPath: props.item.FolderPath,
        IsDefault: props?.item?.IsDefault ?? false,
        Archive: props.item.Archive ?? false,
      });
    }
  }

  const onChangeForm = (e) => {

    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    } else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

  }

  function validationCheck() {
    if (dataItem.Name == undefined || dataItem.Name.trim().length == 0 || dataItem.Name == "") {
      toast.error(`${lang.please_enter_name_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    if (dataItem.BucketConfiguration == undefined || Object.keys(dataItem.BucketConfiguration).length == 0) {
      toast.error(
        <div>
          <strong>INVALID</strong>
          <div style={{ fontSize: '13px' }}>{lang.please_select_bucket_configuration_error_message}</div>
        </div>,
        { position: toast.POSITION.TOP_RIGHT }
      );
      return false;
    }
    if (dataItem.FolderPath == undefined || dataItem.FolderPath.trim().length == 0 || dataItem.FolderPath == "") {
      toast.error(`${lang.please_enter_folder_path_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    return true;
  }

  const onGetFilesFromBucket = async () => {

    if (validationCheck()) {

      setFileLoading(true);

      let res = await API.getFilesFromBucket({ bucketObj: dataItem });
      if (res.success) {
        setFileLoading(false);
        setFileList(res.data);
      }
    }
  }


  const handleSubmit = async (e) => {

    if (validationCheck()) {
      const saveData = {
        _id: dataItem._id,
        SID: dataItem.SID ?? 0,
        Name: dataItem.Name,
        BucketConfiguration_id: dataItem.BucketConfiguration._id,
        FolderPath: dataItem.FolderPath,
        IsDefault: dataItem.IsDefault ?? false,
        Archive: dataItem.Archive ?? false,
      }
      console.log(saveData);

      let res = await API.saveData(ENTITYNAME.BUCKETS, saveData);
      if (res.success) {
        let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.BUCKETS, data: res.data, message: res.message };
        API.SaveLogs(logData);
        utility.deleteLocalStorageItem(ENTITYNAME.BUCKETS);
        props.cancelEdit();
        props.refresh();
      }
      else {
        toast.error(res.message, {
          position: toast.POSITION.TOP_RIGHT
        });
      }
    }
  }

  const MyIconCell = (p) => {
    return (
      <td style={{ textAlign: "center" }}>
        <i
          className={`fa-solid fa-${p.dataItem[p.field]} fa-lg`}
          //   style={{ backgroundColor: 'white', color: isFolder ? 'green' : 'red', borderRadius: '7px' }}
          aria-hidden="true"
        ></i>
      </td>
    );
  };

  return (
    <BossDialog
      title={props.item.SID > 0 ? props.item.Name : "Create Bucket"}
      onClose={props.cancelEdit}
      width={"770px"}
    >
      <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
      <Form
        initialValues={dataItem}
        render={(formRenderProps) => (
          <FormElement>
            <div className="row mt-2">
              <div className="col-12">
                <div className="row">
                  <div className="col-6">
                    <label>{lang.name_label} *</label>
                    <input
                      name={"Name"}
                      type="text"
                      className="form-control form-control-sm"
                      onChange={onChangeForm}
                      value={dataItem.Name}
                    />
                  </div>
                  <div className="col-6">
                    <label htmlFor="">{lang.bucket_config_label}</label>
                    <DropDownList
                      style={{ backgroundColor: 'white' }}
                      data={bucketConfigurations}
                      name="BucketConfiguration"
                      textField="Name"
                      dataItemKey="_id"
                      value={dataItem.BucketConfiguration}
                      onChange={onChangeForm}
                    />
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="form-group col-12">
                    <label htmlFor="">{lang.folder_path_label} *</label><br />
                    <div style={{ display: "flex" }}>
                      <input name="FolderPath" type="text" className="d-inline form-control form-control-sm" value={dataItem.FolderPath} onChange={onChangeForm} />
                      <button type="button" title='Check Files' className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                        style={{ height: "30px", marginLeft: "10px" }} onClick={onGetFilesFromBucket}>
                        {fileLoading ? <i className="fa-solid fa-rotate fa-spin" /> : <i className="fa-brands fa-searchengin" />}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-6">
                    <input type='checkbox'
                      name='IsDefault'
                      value={dataItem.IsDefault}
                      checked={dataItem.IsDefault}
                      onClick={onChangeForm}
                      className='mt-1'
                    />
                    <label className='ml-2'>{lang.is_default_label}</label>
                  </div>
                  <div className="col-2" >
                    <input type={"checkbox"} name={"Archive"}
                      onChange={(e) => onChangeForm(e)}
                      value={dataItem.Archive}
                      checked={dataItem.Archive} />
                    <label className="ml-1">{lang.archive}</label>
                  </div>
                </div>

                {fileList.length > 0 && <Grid data={fileList} style={{ height: "30vh", marginTop: "10px" }}>
                  <GridColumn field="type" title={lang.type_column} width={50} cell={MyIconCell} />
                  <GridColumn field="name" title={lang.name_label} />
                  <GridColumn field="size" title={lang.size_label} cell={ByteToSizeCell} />
                </Grid>}
                {fileList.length > 0 && <div className="text-right mt-1">{`Total : ${fileList.length}`}</div>}
              </div>
            </div>
          </FormElement>
        )}
      />

    </BossDialog>)
};